// Libs
import React from 'react'
import styled, { css } from 'styled-components'

// Comps
import { colors } from '../../../utils'

export const waitingListButtonStyles = css`
  .book-button {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 238px;

    .buttonIcon {
      height: 24px;
      margin-right: 5px;
      width: 24px;
    }
  }

  .button-dropdown-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    padding: 13px 10px;
    width: 234px;
    background: #ffffff;
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
    border-radius: 6px;

    .option-button {
      cursor: pointer;
      display: flex;

      align-items: center;
      padding: 14px;
      background: none;
      border: none;
      border-radius: 6px;
      outline: none;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: -0.5px;
      line-height: 110%;
      text-align: left;
      transition: 150ms ease-in-out background;

      &.light:hover {
        background-color: #f0edfd;
        svg.circle circle {
          &:not(:first-of-type) {
            stroke: ${colors.grey};
            fill: ${colors.grey};
          }
        }
      }

      &.light.active {
        color: ${colors.purple};

        .option-icon {
          path {
            stroke: ${colors.purple};
          }
        }

        svg.circle circle {
          stroke: ${colors.purple};
          &:not(:first-of-type) {
            stroke: ${colors.purple};
            fill: ${colors.purple};
          }
        }
      }

      &.dark:hover {
        background-color: ${colors.lightGray};
        svg.circle circle {
          &:not(:first-of-type) {
            stroke: ${colors.grey};
            fill: ${colors.grey};
          }
        }
      }

      &.dark.active {
        color: ${colors.black};

        .option-icon {
          path {
            stroke: ${colors.black};
          }
        }

        svg.circle circle {
          stroke: ${colors.veryDarkGray};
          &:not(:first-of-type) {
            stroke: ${colors.veryDarkGray};
            fill: ${colors.veryDarkGray};
          }
        }
      }

      .option-icon {
        margin-right: 10px;
        path {
          stroke: ${colors.black};
        }
        /* path {
          stroke: ${colors.grey};
          fill: ${colors.grey};
        } */
      }

      svg.circle {
        margin-left: auto;
        circle {
          stroke: ${colors.grey};
          &:not(:first-of-type) {
            stroke: transparent;
            fill: transparent;
          }
        }
      }
    }
  }
`
